/**
 * Block Registry Barrel Export
 *
 * Entry point for the block registry. Importing this module:
 * 1. Registers all built-in block types
 * 2. Exports registry functions for lookup and enumeration
 * 3. Exports types for custom block registration
 *
 * Registration happens synchronously at module load time, so any code
 * importing from "@/canvas/registry" gets an initialized registry.
 */

// Import registry functions
export {
  registerBlock,
  getBlockConfig,
  getBlockComponent,
  getAllBlockTypes,
  getAllBlockConfigs,
  getAddBlockMenuConfigs,
} from "./registry";

// Export types
export type { BlockConfig, BlockOfType } from "./types";

// Import block configs for registration
import { markdownBlockConfig } from "./blocks/markdown";
import { risksBlockConfig } from "./blocks/risks";
import { contradictionsBlockConfig } from "./blocks/contradictions";
import { timelineBlockConfig } from "./blocks/timeline";
import { imageBlockConfig } from "./blocks/image";
import { dividerBlockConfig } from "./blocks/divider";
import { calloutBlockConfig } from "./blocks/callout";
import { stakeholdersBlockConfig } from "./blocks/stakeholders";
import { tableBlockConfig } from "./blocks/table";
import { requirementsBlockConfig } from "./blocks/requirements";

// Import registerBlock for side-effect registration
import { registerBlock } from "./registry";

// Register all built-in blocks (side effect at module load)
registerBlock(markdownBlockConfig);
registerBlock(risksBlockConfig);
registerBlock(contradictionsBlockConfig);
registerBlock(timelineBlockConfig);
registerBlock(imageBlockConfig);
registerBlock(dividerBlockConfig);
registerBlock(calloutBlockConfig);
registerBlock(stakeholdersBlockConfig);
registerBlock(tableBlockConfig);
registerBlock(requirementsBlockConfig);
